import React from 'react';

/**
 * Footer - Layout Component
 *
 * Simple footer with USML motto and copyright
 * Tactical Precision styling
 */
export const Footer = ({ className = '', ...props }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`tp-footer ${className}`.trim()} {...props}>
      <div className="tp-container">
        <div className="tp-footer__content">
          <div className="tp-footer__section">
            <h4 className="tp-footer__title">USML</h4>
            <p className="tp-footer__text">
              Unidad de Simulación Militar Latina
            </p>
            <p className="tp-footer__motto">
              "VELOCIDAD, SORPRESA Y VIOLENCIA"
            </p>
          </div>

          <div className="tp-footer__section">
            <h4 className="tp-footer__title">Comunidad</h4>
            <p className="tp-footer__text">
              <a href="https://discord.gg/4PcYVxGrNk" target="_blank" rel="noopener noreferrer">
                Discord
              </a>
            </p>
            <p className="tp-footer__text">
              <a href="https://www.instagram.com/clan.usml/" target="_blank" rel="noopener noreferrer">
                Instagram
              </a>
            </p>
            <p className="tp-footer__text">
              <a href="https://www.youtube.com/@unidaddesimulacionmilitarl7341" target="_blank" rel="noopener noreferrer">
                Youtube
              </a>
            </p>
          </div>

          <div className="tp-footer__section">
            <h4 className="tp-footer__title">USML</h4>
            <p className="tp-footer__text">
              Clan de simulación militar Latinoamericano
            </p>
          </div>
        </div>

        <div className="tp-footer__bottom">
          <p>
            © {currentYear} USML - Unidad de Simulación Militar Latina. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
